module.exports = __webpack_public_path__ + "static/media/background-information@2x.4ec754c2.jpg";